import { IconButton } from '@chakra-ui/react'
import { BiRefresh } from 'react-icons/bi'
import React from 'react'

const ReplaceButton = ({replaceQuestion}) => {
  return (
    <IconButton float={'right'} isRound onClick={replaceQuestion} variant={'outline'} aria-label='Replace Question' icon={<BiRefresh/>}/>
  )
}

export default ReplaceButton